module.exports = __webpack_public_path__ + "img/logo-ab.fc55350e.png";